import { BusinessError } from './interfaces';

export const businessErrorFactory = ({ message, severity = 'warning' }: BusinessError) => ({
  message,
  severity
});
